import { getAllCountries } from 'api/other';
import { useQuery, useMutation, useQueries } from 'react-query';


export function useAllCountries () {

  return useQuery(
    'getAllCountries',
    getAllCountries,
    {
      staleTime: Infinity,
    }
  );

}